export const defaultValue = {
    id: '',
    action: '',
    description: '',
    active: true,
    isCallCenterRelated: true,
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
};
